module.exports = __webpack_public_path__ + "static/img/naniungo-slide-21.8bc9906a.jpg";